import styled from 'styled-components';
import { CenterFlexCSS } from 'styles/common';

export const Previews = styled.div`
  padding: 0.25rem 0.5rem;
`;

export const Preview = styled.div`
  // display: inline-block;
  // height: 100%;
  position: relative;
  // border: 1px solid ${(props) => props.theme.palette.divider};
  padding: 2px;
  display: flex;
  justify-content: center;
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  ${CenterFlexCSS};
  // background: #000000fa;
`;
export const ImagePreview = styled.img`
  overflow-y: hidden;
  object-fit: cover;
  max-width: 100%;
  // height: 100%;
  border-radius: 4px;
  opacity: ${(props) => (props.isUploaded ? 1 : 0.5)};
  max-height: 40vh;
  margin: 0 auto;
`;

export const DeleteContainer = styled.div`
  display: none;
  padding: 0.25rem;
  background: #000a;
  border-radius: 50%;
  color: white;
  svg {
    fill: white;
  }
  ${OverlayContainer}:hover & {
    display: block;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  padding: 0.25rem 0.5rem 0.25rem 0.25rem;
  background: #000a;
  border-radius: 8px;
  color: white;
  svg {
    fill: white;
  }
  ${CenterFlexCSS};
  ${OverlayContainer}:hover & {
    display: none;
  }
`;
export const ImageIconContainer = styled.div`
  position: absolute;
  right: 0.5rem;
  bottom: 0.5rem;
`;
